<script setup>
import SurveyTable from '@/views/survey/SurveyTable2.vue'
import EventSurveyAnalytics from '@/views/survey/dashboard/EventSurveyAnalytics.vue'
import SurveyResponseAnalytics from '@/views/survey/dashboard/SurveyResponseAnalytics.vue'

definePage({
  meta: {
    name: 'survey-entry-event',
    subject: 'survey.menu',
    action: 'survey_entry_event',
  },  
})
</script>

<template>
  <div>
    <VRow>
      <!-- page title -->
      <VCol cols="12">
        <span class="text-h3 font-weight-bold text-primary text-capitalize">
          Event Survey
        </span>
      </VCol>
      <VCol cols="6">
        <EventSurveyAnalytics />
      </VCol>
      <VCol cols="6">
        <SurveyResponseAnalytics />
      </VCol>
    </VRow>
    <SurveyTable
      class="mt-3"
      page-type="Event"
    />
  </div>
</template>
